import React, { FC, useEffect, useState } from 'react';
import Styles from './CheckCoverage.module.scss';
import NewLCInput from './NewLCInput';
import AdvanceSearch from './AdvanceSearch';
import SuccessCoverage from './SuccessCoverage';
import { replacePlaceholder, viewport } from '../../utils/utils';
import RichText from '../richtext';
import { fetchLineCheck } from './CoverageCheckUtils';
import { getCookie, deleteCookie, setCookie } from 'cookies-next';
import {
  AUTHCOOKIE,
  GAEVENT,
  SBLINECHECKEXIT,
  SBLINECHECKRESULT,
  SBLINECHECKSTART
} from '../../Analytics/AnalyticsConstants';
import { LocationFinder } from './LocationFinder';
import { trackGADatalayerEvent } from '../../utils/AnalyticsUtils';

const CheckCoverageComponent: FC<any> = ({
  content,
  handleModal,
  openModal,
  isFetchingLineCheck,
  productName,
  onSuccess,
  onCreateCart,
  lineCheckOnClear,
  isModal,
  setShowModal,
  productId
}) => {
  const elementRef = React.useRef<HTMLDivElement>(null);
  const inputRef = React.useRef<HTMLDivElement>(null);
  const [timeoutID, setTimeoutID] = useState<NodeJS.Timeout | null>(null);

  const isFetchingRef = React.useRef(isFetchingLineCheck);
  const startTimeRef = React.useRef<number>(0);

  const [lcData, setLcData] = useState<any>({
    errMsg: '',
    selectedAddress: '',
    addressList: {},
    fetchingLineCheck: isFetchingLineCheck,
    linecheckResponse: {},
    apiError: false,
    buttonClick: false,
    adv: false,
    newCustomer: true,
    retry: false
  });

  const lcDataRef = React.useRef(lcData);
  useEffect(() => {
    lcDataRef.current = lcData;
  }, [lcData]);

  const [advData, setAdvData] = useState<any>({
    advOpen: false,
    advAddress: {},
    fetchAdvCheck: false,
    openOverlay: false,
    advButton: false
  });

  const [animateOverlay, setAnimateOverlay] = useState(false);
  const [clearOnClose, setClearOnClose] = useState(false);
  const [elementTop, setElementTop] = useState(0);
  const openInOverlay = openModal != undefined ? openModal : false;

  const checkAddress = () => {
    //to open the component as overlay for mobileview
    if (isMobile && !advData?.openOverlay) {
      setAdvData({ ...advData, openOverlay: true });
    }
    setLcData({
      ...lcData,
      buttonClick: true
    });
    setClearOnClose(false);

    lcData?.selectedAddress == '' ||
    Object?.keys(lcData?.addressList)?.length === 0 ||
    !lcData?.newCustomer
      ? setLcData({ ...lcData, errMsg: content?.requiredErrText })
      : setLcData({ ...lcData, errMsg: '' });

    if (Object?.keys(lcData?.addressList)?.length !== 0) {
      deleteCookie('chAddressJson');
      typeof lineCheckOnClear === 'function' && !isMobile && isModal && lineCheckOnClear();

      setLcData({ ...lcData, fetchingLineCheck: true });

      const openMobileOverlay =
        isMobile && !isModal ? openInOverlay : !isMobile && !openInOverlay ? false : true;

      trackGADatalayerEvent(GAEVENT, SBLINECHECKSTART, {
        coverage_address: `${lcData?.addressList?.postCode}|${lcData?.addressList?.city}`,
        component: 'Line Check'
      });
      const startTime = performance.now();
      startTimeRef.current = startTime;

      fetchLineCheck(lcData?.addressList, setLcData, lcData)
        .then((res: any) => {
          setLcData({
            ...lcData,
            linecheckResponse: res,
            buttonClick: false,
            fetchingLineCheck: false
          });
          setAdvData({ ...advData, fetchAdvCheck: false, openOverlay: false });
          setCookie(
            'chAddressJson',
            JSON.stringify({
              addressValue: lcData?.selectedAddress,
              selectedAdd: lcData?.addressList
            }),
            { path: '/', maxAge: 24 * 60 * 60 * 3 }
          );
          // mark the end timestamp and compute elapsed seconds since the fetch started
          if (startTimeRef.current) {
            const endTime = performance.now();
            const waitingTimeSec = Number(((endTime - startTimeRef.current) / 1000).toFixed(2));

            const gaPayload: Record<string, any> = {
              component: 'Line Check',
              coverage_status: res?.eligibleBundle?.length ? true : false,
              waiting_time: waitingTimeSec
            };

            if (res?.lineCheckResponse?.eligibleAccess?.accessType) {
              gaPayload.coverage_type = res?.lineCheckResponse?.eligibleAccess?.accessType;
            }
            if (
              res?.maxUploadDownloadSpeed?.maxBandwidthDown &&
              res?.maxUploadDownloadSpeed?.maxBandwidthUp
            ) {
              gaPayload.coverage_speed = `${res?.maxUploadDownloadSpeed?.maxBandwidthDown}|${res?.maxUploadDownloadSpeed?.maxBandwidthUp}`;
            }
            if (res?.plannedUpgrade) {
              gaPayload.planned_upgrade = res.plannedUpgrade;
            }

            trackGADatalayerEvent(GAEVENT, SBLINECHECKRESULT, gaPayload);
            startTimeRef.current = 0;
          }

          typeof handleModal === 'function' && !isModal && handleModal();
          setTimeout(() => {
            typeof onSuccess === 'function' && onSuccess();
          }, 600);
        })
        .catch((err: any) => {
          // eslint-disable-next-line no-console
          console.log('fetchLineCheck Error:', err);
          setAdvData({ ...advData, fetchAdvCheck: false, openOverlay: openMobileOverlay });
          setLcData({
            ...lcData,
            fetchingLineCheck: false,
            buttonClick: false,
            apiError: true,
            retry: false,
            adv:
              advData?.advAddress &&
              Object?.keys(advData?.advAddress)?.length != 0 &&
              advData?.advButton
                ? true
                : false
          });
        });
    }
  };

  // For clearing the Required Field error when customer types
  useEffect(() => {
    lcData?.buttonClick && lcData?.selectedAddress == ''
      ? setLcData({ ...lcData, errMsg: content?.requiredErrText })
      : setLcData({ ...lcData, errMsg: '' });
  }, [lcData?.selectedAddress, lcData?.buttonClick]);

  // For fetching linecheck if the addressList is changed and button is clicked
  useEffect(() => {
    lcData?.buttonClick && checkAddress();
  }, [lcData?.addressList]);

  //on click of check avilability of advance search
  useEffect(() => {
    if (
      advData?.fetchAdvCheck &&
      advData?.advAddress &&
      Object?.keys(advData?.advAddress)?.length != 0 &&
      advData?.advAddress?.concatedAddress != ''
    ) {
      setAdvData({ ...advData, advOpen: false });
      setLcData({ ...lcData, addressList: advData?.advAddress, buttonClick: true });
    }
  }, [advData?.fetchAdvCheck]);

  //on click of close icon of overlay
  const handleCloseIcon = () => {
    handleModal();
    typeof lineCheckOnClear === 'function' && clearOnClose && lineCheckOnClear();
  };

  //on click of close icon of moble view
  const handleMobileIcon = () => {
    isModal && handleModal();
    setAdvData({ ...advData, openOverlay: false, advOpen: false });
    typeof lineCheckOnClear === 'function' && clearOnClose && lineCheckOnClear();
  };

  const viewPort = viewport();
  const isMobile = viewPort === 'mobile' ? true : false;

  useEffect(() => {
    if (openInOverlay && isMobile) {
      setTimeout(() => {
        setAdvData({ ...advData, openOverlay: true });
        const element = elementRef?.current as HTMLElement;
        element?.focus();
      }, 500);
    } else {
      setAdvData({ ...advData, openOverlay: false });
    }
  }, [viewPort]);

  useEffect(() => {
    const element = elementRef?.current as HTMLElement;
    if ((!advData?.openOverlay && openModal) || isModal) {
      return;
    }

    if (element) {
      if (advData?.openOverlay) {
        document.getElementsByTagName('html')[0].style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';

        const topPos = element?.getBoundingClientRect().top;
        topPos && setElementTop(topPos);
        element?.style.setProperty('top', `${topPos}px`);

        element?.style.setProperty('position', 'fixed');

        const timeId = setTimeout(() => {
          if (element) {
            element?.style.setProperty('top', '');
            setAnimateOverlay(true);
          }
        }, 50);
        setTimeoutID(timeId);
      } else {
        const modal = document.querySelector('.modal-open') as HTMLElement;

        if (!modal) {
          document.getElementsByTagName('html')[0].style.overflow = '';
          document.body.style.overflow = '';
        }
        element?.style.setProperty('top', `${elementTop}px`);
        element?.style.setProperty('height', `211px`);
        const timeId = setTimeout(() => {
          if (element) {
            element?.style.setProperty('top', '');
            element?.style.setProperty('height', '');
            element?.style.setProperty('position', '');

            setAnimateOverlay(false);
          }
        }, 450);
        setTimeoutID(timeId);
      }
    }
  }, [advData?.openOverlay, elementRef?.current]);

  //LINECHECK - for logged customer
  useEffect(() => {
    setLcData({
      ...lcData,

      fetchingLineCheck: isFetchingLineCheck
    });
    //Automates the line check procedure if flag is set in sb AND userLogged in AND address is not there.
    let authData: any = getCookie(AUTHCOOKIE);

    try {
      authData = authData && JSON.parse(authData);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('invalid AuthCookie json');
    }

    let addressData: any = getCookie('chAddressJson');

    if (addressData) {
      try {
        addressData = addressData && JSON.parse(addressData);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('invalid address json');
      }
    } else {
    }

    let localLineCheckResponse: any =
      window &&
      (localStorage.getItem('lineCheckResponse') || localStorage.getItem('lineCheckRepsonse'));

    if (localLineCheckResponse) {
      localLineCheckResponse = JSON.parse(localLineCheckResponse);

      if (
        localLineCheckResponse?.eligibleSpeed &&
        !localLineCheckResponse?.maxUploadDownloadSpeed
      ) {
        localLineCheckResponse['maxUploadDownloadSpeed'] =
          localLineCheckResponse?.eligibleSpeed?.maxSpeed;
      }

      setLcData({
        ...lcData,
        selectedAddress: addressData?.addressValue,
        linecheckResponse: localLineCheckResponse,
        buttonClick: false,
        fetchingLineCheck: false
      });
    }
  }, [isFetchingLineCheck]);

  // For fetching linecheck if logged in customer
  useEffect(() => {
    lcData?.addressList && !lcData?.newCustomer && checkAddress();
  }, [lcData?.newCustomer]);

  const lineCheckOnClearEdit = () => {
    if (isModal && !isMobile) {
      typeof lineCheckOnClear === 'function' && lineCheckOnClear();
    } else if (!isModal) {
      typeof lineCheckOnClear === 'function' && lineCheckOnClear();
    } else {
      setClearOnClose(true);
    }

    typeof handleModal === 'function' && isMobile && !isModal && handleModal();

    setAdvData({ ...advData, openOverlay: true });
  };

  // const openmodalSuccess=openModal?true:false;
  const desktopOverlay = openModal && !isMobile;
  const mobileOverlay = isMobile && advData?.openOverlay;
  const mobileTitleOverlay = isMobile && advData?.openOverlay && openInOverlay;

  // comman data to display for both mobile & desktop view
  const HandleRetry = () => {
    setLcData({
      ...lcData,
      fetchingLineCheck: true,
      apiError: false,
      retry: true
    });
  };

  useEffect(() => {
    if (lcData?.retry) {
      setLcData({
        ...lcData,
        retry: false
      });
      checkAddress();
    }
  }, [lcData?.retry]);

  useEffect(() => {
    let isProcessing = false;

    const handleIntent = () => {
      if (isProcessing || !isFetchingRef.current || startTimeRef.current) return;

      const currentLcData = lcDataRef.current;
      if (!currentLcData?.addressList?.postCode || !currentLcData?.addressList?.city) {
        return;
      }
      isProcessing = true;
      const timeToIntent = Number(((performance.now() - startTimeRef.current) / 1000).toFixed(2));
      //console.log(`Time to intent: ${timeToIntent}s`);

      trackGADatalayerEvent(GAEVENT, SBLINECHECKEXIT, {
        coverage_address: `${currentLcData?.addressList?.postCode}|${currentLcData?.addressList?.city}`,
        component: 'Line Check',
        waiting_time: timeToIntent
      });
      startTimeRef.current = 0;
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        handleIntent();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('blur', handleIntent);
    window.addEventListener('beforeunload', handleIntent);
    window.addEventListener('popstate', handleIntent);

    return () => {
      handleIntent();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('blur', handleIntent);
      window.removeEventListener('beforeunload', handleIntent);
      window.removeEventListener('popstate', handleIntent);
    };
  }, []);

  useEffect(() => {
    isFetchingRef.current = isFetchingLineCheck || lcData?.fetchingLineCheck;
  }, [isFetchingLineCheck, lcData?.fetchingLineCheck]);

  const loadingMessages: Array<string> = Array.isArray(content?.messages)
    ? content.messages
        .map((item: { text?: string }) => (typeof item?.text === 'string' ? item.text.trim() : ''))
        .filter((text: string) => text.length > 0)
    : [];

  return (
    <>
      <div
        className={`${Styles['main-container']} 
      ${advData?.openOverlay ? Styles['mobile-overlay'] : ''} 
      ${animateOverlay ? Styles['mobile-overlay-animation'] : ''}`}
        ref={elementRef}
      >
        {((lcData?.linecheckResponse && Object?.keys(lcData?.linecheckResponse)?.length != 0) ||
          lcData?.adv) &&
        !isFetchingLineCheck ? (
          <SuccessCoverage
            content={content}
            data={lcData?.linecheckResponse}
            lcData={lcData}
            setLcData={setLcData}
            advData={advData}
            desktopOverlay={desktopOverlay}
            mobileOverlay={mobileOverlay}
            handleModal={handleModal}
            setAdvData={setAdvData}
            productName={productName}
            productId={productId}
            onCreateCart={onCreateCart}
            lineCheckOnClear={lineCheckOnClearEdit}
            isModal={isModal}
            setShowModal={setShowModal}
            isMobile={isMobile}
          />
        ) : (
          <div
            className={`row d-flex justify-content-center col-11 col-sm-8 col-md-6 col-lg-8 mx-auto ${
              Styles.container
            } ${lcData?.apiError ? Styles['serverError'] : ''} ${
              advData?.openOverlay ? Styles['overlay-container'] : ''
            } 
            `}
          >
            {content?.title && (
              <>
                <div className={Styles?.headerContainer}>
                  {content?.coverageIcon?.filename && (
                    <img
                      src={content?.coverageIcon?.filename}
                      height={isMobile ? 26 : 34}
                      width={isMobile ? 24 : 30}
                      alt='coverageIcon'
                    />
                  )}
                  <div className={Styles.CoverageTitle}>
                    {desktopOverlay || mobileTitleOverlay
                      ? replacePlaceholder(content?.overlayTitle, [productName])
                      : content?.title}
                  </div>
                  {content?.closeIcon?.filename && (desktopOverlay || mobileOverlay) && (
                    <div
                      className={desktopOverlay ? Styles['overlay-close'] : Styles['cross-icon']}
                      onClick={() => (mobileOverlay ? handleMobileIcon() : handleCloseIcon())}
                    >
                      <img
                        src={content?.closeIcon?.filename}
                        height={14}
                        width={14}
                        alt='cross-icon'
                      />
                    </div>
                  )}
                </div>
              </>
            )}
            <div className={Styles.separator}></div>
            {!advData?.advOpen && lcData?.apiError && !lcData?.fetchingLineCheck && (
              <>
                <div className={Styles.serverErrContainer}>
                  {' '}
                  <div className={Styles.successTitleIcon}>
                    {content?.addNotFoundIcon?.filename && (
                      <img
                        src={content?.addNotFoundIcon?.filename}
                        height={32}
                        width={32}
                        alt='LineCheck icon'
                      />
                    )}
                    {content?.serverTimeoutTitle && (
                      <h4 className={Styles.successTitle}>{content?.serverTimeoutTitle}</h4>
                    )}
                    {/* Description below Title - only for adv search */}
                    {
                      <p className={Styles.advanceSearchErrDescription}>
                        <RichText content={content?.serverTimeoutDesc} />
                      </p>
                    }
                    <button
                      className={`falcon-secondary-button-v1 ${Styles.retryButton}`}
                      onClick={HandleRetry}
                    >
                      <img
                        src={content?.retryIcon?.filename}
                        height={18}
                        width={18}
                        alt='retryIcon'
                      />
                      {content?.retryButton}
                    </button>
                  </div>
                </div>
              </>
            )}
            {!advData?.advOpen && !lcData?.apiError && (
              <>
                {lcData?.fetchingLineCheck || isFetchingLineCheck ? (
                  <div className={Styles['spinnercontainers']}>
                    {
                      <>
                        {loadingMessages?.length ? (
                          <LocationFinder
                            messages={loadingMessages}
                            timeBetweenMessages={content?.timeBetweenMessages}
                            timeLastMessage={content?.timeLastMessage}
                          ></LocationFinder>
                        ) : (
                          <>
                            <div
                              className={`spinner-border ${Styles['spinnersrotxte']} `}
                              role='status'
                            ></div>

                            {(content?.checkingServiceTxt || content?.lookingAddressTxt) && (
                              <div className={Styles['checktextcontainer']}>
                                {advData?.fetchAdvCheck &&
                                advData?.advAddress?.concatedAddress != ''
                                  ? content?.lookingAddressTxt
                                  : content?.checkingServiceTxt}
                              </div>
                            )}
                          </>
                        )}
                      </>
                    }
                  </div>
                ) : (
                  <div className={`${Styles['line-container']}`}>
                    <div className={`${Styles.LineCheckInput}`}>
                      <NewLCInput
                        content={content}
                        setLcData={setLcData}
                        lcData={lcData}
                        advData={advData}
                        setAdvData={setAdvData}
                        ref={inputRef}
                      />
                      {lcData?.errMsg && <div className={Styles.reqText}>{lcData?.errMsg}</div>}
                    </div>
                    {content && content?.checkBtn && (
                      <div className={`${Styles['checkoutButton']}`}>
                        <button
                          name='check address button'
                          type='button'
                          className={`primarybutton`}
                          disabled={false}
                          onClick={checkAddress}
                          style={{ width: '100%', position: 'relative' }}
                        >
                          {content?.checkBtn}
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
            {advData?.advOpen && (
              <AdvanceSearch
                content={content}
                setAdvData={setAdvData}
                advData={advData}
                setLcData={setLcData}
                lcData={lcData}
              />
            )}
          </div>
        )}
      </div>
      {!isModal ? (
        <div
          className={`${Styles['mobile-overlay-block']} ${
            advData?.openOverlay ? Styles['mobile-overlay-block-animation'] : ''
          } `}
        >
          &nbsp;
        </div>
      ) : null}
    </>
  );
};
export default CheckCoverageComponent;
